export const CONSULT_NAME_PATTERN = '^[a-zA-Z가-힣\\s]{1,20}$';
